export const showInstagram = () => {
    let instagram = document.querySelector('.instagram');
    (async () => {
        try {
            instagram.classList.add('preloader');
            const rawResponse = await fetch(`/ajax.php`, {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: 'data=' + JSON.stringify({
                    'path': 'get_instagram'
                })
            });

            const content = await rawResponse.json();
            if (content.success) {
                instagram.innerHTML = content.data
                if (document.querySelector('#insta-tabs')) {
                    let tabs = async () => await import('./ui_tabs');
                    tabs().then(t => t.init({
                        elm: "#insta-tabs",
                        shouldScrollTabIntoView: false,
                    }).init());
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            instagram.classList.remove('preloader');
        }
    })();
}